import React from 'react';
import { Tab } from 'semantic-ui-react';
import EventService from 'src/services/api/eventService';
import CreateService from 'src/containers/events/service-creation/createService';
import ChurchServiceGuests from 'src/containers/events/churchServiceGuests';
import { sortObjects, chPerm } from 'src/components/helpers';
import GenerateLinksModal from 'src/containers/events/generateLinksModal';
import PendingEventGuestsModal from 'src/containers/events/pending-guests';
import moment from 'src/services/moment_instance';
import AGTable from 'src/components/table/aggrid';
import { ServiceListRowDef } from 'src/components/common/rows/ServiceListRow';
import { ServiceContainer } from 'src/assets/styles/components/reservation';
import ServicesMonthCalendar, { ServiceMonthPicker } from 'src/pages/events/ServicesMonthCalendar';

const ViewAllServices = (props) => {
  const returnState = props.location?.state || {};
  const [loading, set_loading] = React.useState(false);
  const [activeTab, set_activeTab] = React.useState(0);
  const [services, set_services] = React.useState({});
  const [serviceList, set_serviceList] = React.useState([]);
  const [inputs, setInputs] = React.useState(() =>
    returnState.eventSlugname ? { eventSlugname: returnState.eventSlugname } : {}
  );
  const [serviceAttendance, set_serviceAttendance] = React.useState([]);
  const [previousEventsNames, set_previousEventsNames] = React.useState([]);
  const [clickedEvent, set_clickedEvent] = React.useState({});
  const [handleDate, set_handleDate] = React.useState(() => {
    const month = returnState.date ? moment(returnState.date) : moment();
    return {
      startDate: month.clone().startOf('month').startOf('day'),
      endDate: month.clone().endOf('month').endOf('day'),
    };
  });
  const getDate = (date) => moment.tz(date, 'America/Bogota').format('YYYY-MM-DD');
  const visibleMonth = handleDate.startDate.clone().startOf('month');

  React.useEffect(() => {
    getPreviousEventNames(60, 365);
  }, []);

  React.useEffect(() => {
    getEvents();
  }, [inputs.startDate, inputs.endDate]);

  const getEvents = () => {
    const { startDate, endDate } = inputs;
    set_loading(true);
    set_services({});
    set_serviceList([]);

    let body = {
      startDate: startDate || handleDate?.startDate?.toDate(),
      endDate: endDate || handleDate?.endDate?.toDate(),
      withGuests: true,
    };
    EventService.getAuditoriumEvents(body)
      .then((response) => {
        if (response.data.success) {
          set_loading(false);
          let events = {};
          let eventList = [];
          sortObjects(response.data.events, 'date', 'asc').forEach((event) => {
            const day = getDate(event.date);
            events[day] = [...(events[day] || []), event];
            if (event.eventSlugname !== 'Auditorio_Principal') eventList.push(event);
          });
          set_services(events);
          set_serviceList(eventList);
        }
      })
      .catch((err) => {
        set_loading(false);
      });
  };

  const getEvent = (id, eventSlugname) => {
    set_loading(true);
    EventService.eventAttendance({ id, eventSlugname })
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          set_serviceAttendance(response.data.event);
        }
      })
      .catch((err) => {
        set_loading(false);
      });
  };

  const getPreviousEventNames = (numberPrevDays = 9999, numberPostDays = 9999) => {
    set_loading(true);
    const body = {
      prevDays: numberPrevDays,
      postDays: numberPostDays,
    };
    EventService.getEventsNames(body)
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          set_previousEventsNames(response.data.eventsNames);
          if (!inputs.eventSlugname) {
            setInputs((prev) => ({
              ...prev,
              eventSlugname: response.data.eventsNames[0],
            }));
          }
        }
      })
      .catch((err) => {
        set_loading(false);
      });
  };

  const handleMonthChange = (month) => {
    const startDate = month.clone().startOf('month').startOf('day');
    const endDate = month.clone().endOf('month').endOf('day');
    setInputs((prev) => ({
      ...prev,
      startDate: startDate.toDate().getTime(),
      endDate: endDate.toDate().getTime(),
    }));
    set_handleDate({ startDate, endDate });
  };

  const panes = [
    {
      menuItem: 'Calendario',
      render: () => (
        <Tab.Pane>
          <ServicesMonthCalendar
            month={visibleMonth}
            services={services}
            loading={loading}
            onOpenService={(service) => {
              getEvent(service.id, service.eventSlugname);
              set_clickedEvent(service);
            }}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Agenda',
      render: () => (
        <Tab.Pane>
          {loading && <p>Cargando servicio...</p>}
          <AGTable
            rowData={serviceList}
            rowHeight={60}
            columnDefs={ServiceListRowDef(getEvent, set_clickedEvent)}
            defaultCol={{
              suppressMovable: true,
            }}
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <ServiceContainer className="selectAService">
      <h1
        style={{
          display: 'block',
          padding: '20px',
          textAlign: 'center',
          fontSize: '45px',
        }}
      >
        Servicios y Eventos
      </h1>
      {!clickedEvent?.id ? (
        <>
          <>
            {chPerm(['Auditorio_PrincipalAdmin']) && (
              <CreateService eventSlugname={inputs.eventSlugname} />
            )}
            <GenerateLinksModal previousEventsNames={previousEventsNames} />
          </>

          <ServiceMonthPicker month={visibleMonth} onChange={handleMonthChange} />
          <Tab
            panes={panes}
            onTabChange={(e, { activeIndex }) => set_activeTab(activeIndex)}
            activeIndex={activeTab}
          />
          {chPerm(['eventAdmin']) && (
            <div style={{ padding: '20px 0 0 0' }}>
              <PendingEventGuestsModal />
            </div>
          )}
        </>
      ) : (
        <ChurchServiceGuests
          set_serviceAttendance={set_serviceAttendance}
          set_clickedEvent={set_clickedEvent}
          serviceAttendance={serviceAttendance}
          clickedEvent={clickedEvent}
          history={props.history}
          getEvents={getEvents}
          getPreviousEventNames={getPreviousEventNames}
          getEvent={getEvent}
        />
      )}
    </ServiceContainer>
  );
};

export default ViewAllServices;
